import { INTERACT_ACTION_TYPES } from '../actions/action_types';

export const initialState = {
  displayPopupOverlay: false,
  popupClass: '',
  displayConfirmation: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case INTERACT_ACTION_TYPES.SET_CONFIRMATION_DIALOG_VISIBILITY:
      return { ...state, displayConfirmation: payload.show };
    case INTERACT_ACTION_TYPES.TOGGLE_POPUP:
      return { ...state, displayPopupOverlay: payload.isOpened, popupClass: payload.popupClass };
    default:
      return state;
  }
};
